module.exports = __webpack_public_path__ + "media/bell.96fa4252.mp3";